import { Component, computed, inject, input, output, signal } from '@angular/core';
import { LucideModule } from '../../../../../shared/modules/lucide.module';
import { CartaoAcessoSicComponent } from '../cartao-acesso-sic/cartao-acesso-sic.component';
import { PedidoSicStore } from '../pedido-sic.store';

interface OrientacaoSic {
  id: string;
  titulo: string;
  icone: string;
  conteudo: string;
}

const ORIENTACOES: readonly OrientacaoSic[] = [
  {
    id: 'o-que-e',
    titulo: 'O que é o e-SIC?',
    icone: 'circle-help',
    conteudo:
      'O Serviço de Informação ao Cidadão (SIC) é o canal pelo qual qualquer pessoa pode pedir acesso a ' +
      'informações públicas produzidas ou custodiadas pela Prefeitura de Salvador, conforme a Lei de ' +
      'Acesso à Informação (Lei nº 12.527/2011). O e-SIC é a versão eletrônica desse serviço: o pedido é ' +
      'registrado, recebe um protocolo e pode ser acompanhado pelo portal.',
  },
  {
    id: 'pode-ser-solicitado',
    titulo: 'O que pode ser solicitado?',
    icone: 'file-check-2',
    conteudo:
      'Podem ser solicitados dados e documentos de interesse público: execução orçamentária e ' +
      'financeira, contratos, convênios, licitações, folha de pagamento, relatórios de gestão, atas, ' +
      'pareceres, estudos técnicos e informações sobre a prestação de serviços municipais. O pedido deve ' +
      'ser objetivo e indicar com clareza a informação desejada.',
  },
  {
    id: 'nao-deve-ser-solicitado',
    titulo: 'O que NÃO deve ser solicitado?',
    icone: 'circle-alert',
    conteudo:
      'Não são atendidos pelo e-SIC: reclamações, denúncias, elogios e solicitações de serviço — esses ' +
      'casos devem ir para a Ouvidoria. Também não cabem pedidos genéricos ou desproporcionais, pedidos ' +
      'de consultoria e análise jurídica, dados pessoais de terceiros protegidos pela LGPD e informações ' +
      'classificadas como sigilosas nos termos da lei.',
  },
  {
    id: 'prazo',
    titulo: 'Qual o prazo de resposta?',
    icone: 'clock',
    conteudo:
      'A resposta é enviada em até 20 dias corridos, prorrogáveis por mais 10 dias mediante ' +
      'justificativa expressa — prazo máximo de 30 dias, conforme o art. 11 da Lei nº 12.527/2011. Se a ' +
      'informação estiver disponível de imediato, o acesso é concedido na hora.',
  },
  {
    id: 'recurso',
    titulo: 'Possibilidade de recurso',
    icone: 'shield-alert',
    conteudo:
      'Se o pedido for negado ou a resposta for considerada insuficiente, cabe recurso em até 10 dias a ' +
      'contar da ciência da decisão. O recurso é dirigido à autoridade hierarquicamente superior à que ' +
      'proferiu a decisão, que tem 5 dias para se manifestar. Persistindo a negativa, cabe nova instância ' +
      'junto à Controladoria Geral do Município.',
  },
  {
    id: 'lgpd',
    titulo: 'Conformidade LGPD',
    icone: 'lock',
    conteudo:
      'Os dados informados neste pedido são tratados exclusivamente para registrar, analisar e responder ' +
      'à solicitação, conforme a Lei nº 13.709/2018 (LGPD). O acesso é restrito aos servidores ' +
      'responsáveis pela tramitação e você pode, a qualquer tempo, solicitar informações sobre o ' +
      'tratamento dos seus dados.',
  },
];

@Component({
  selector: 'app-etapa-orientacoes-sic',
  templateUrl: './etapa-orientacoes-sic.component.html',
  styleUrls: ['./etapa-orientacoes-sic.component.css'],
  imports: [LucideModule, CartaoAcessoSicComponent],
})
export class EtapaOrientacoesSicComponent {
  protected readonly store = inject(PedidoSicStore);

  /** Cada incremento vindo do pai leva o cursor até o card de acesso. */
  readonly focarLogin = input(0);

  readonly continuar = output<void>();

  readonly autenticado = output<void>();

  readonly acessarGov = output<void>();

  readonly seguirAnonimo = output<void>();

  readonly saiu = output<void>();

  readonly orientacoes = ORIENTACOES;

  readonly orientacaoAberta = signal<string>('o-que-e');

  /** Ligado ao tentar acessar sem marcar o aceite; destaca o campo que falta. */
  readonly aceiteDestacado = signal(false);

  /** A recusa do servidor por falta de aceite traz o cidadão de volta para cá, com a mensagem. */
  readonly errosServidor = computed(() => this.store.errosServidor()['orientacoes'] ?? []);

  alternarOrientacao(id: string): void {
    this.orientacaoAberta.update((aberta) => (aberta === id ? '' : id));
  }

  alternarAceite(evento: Event): void {
    const marcado = (evento.target as HTMLInputElement).checked;

    this.store.orientacoesAceitas.set(marcado);

    if (marcado) {
      this.aceiteDestacado.set(false);
    }
  }

  destacarAceite(): void {
    this.aceiteDestacado.set(true);
  }
}
